import { render, staticRenderFns } from "./hair-dryer.vue?vue&type=template&id=2582f437&scoped=true"
import script from "./hair-dryer.vue?vue&type=script&lang=js"
export * from "./hair-dryer.vue?vue&type=script&lang=js"
import style0 from "./hair-dryer.vue?vue&type=style&index=0&id=2582f437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582f437",
  null
  
)

export default component.exports